<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.5 10.5L10.5 10.5L10.5 5.5" stroke="currentColor" stroke-linecap="round"/>
</svg>
